<script lang="ts" setup>
import { set, useEventListener } from '@vueuse/core';
import { onMounted, ref, toValue } from 'vue';
import { useSlideDataset } from '../services/use.configurator-slide.js';
import { useInputLimit } from '../services/use.input-limit.js';
import { useParentStepElement } from '../services/use.parent-step.js';
import { useStepperBlock } from '../services/use.stepper-block.js';
import { useStoredValue } from './services/use.store.js';

const shouldBlockValidation = ref(false);
const passedSubmissionOnce = ref(false);

const { datasetValue: placeholder } = useSlideDataset('placeholder');
const { datasetValue: nonFilledError } = useSlideDataset('nonFilledError');
const {
  // @ts-expect-error vv
// biome-ignore lint/correctness/noUnusedVariables: Line is used but not as a token.
  inputRef, limit, currentLength, updateCurrentLength, debouncedUpdateCurrentLength
} = useInputLimit(250, { debounceTimeInMs: 25 });
const { value, setValue } = useStoredValue();
const { parentStepElement } = useParentStepElement();
const { isEnabled } = useStepperBlock('pick-a-card--message', async () => !toValue(shouldBlockValidation));

useEventListener(parentStepElement, 'click', (e: MouseEvent) => {
  const targetHTMLElement = e.target as HTMLElement;
  if (targetHTMLElement.dataset.action === 'next-step') {
    e.preventDefault();

    if (!toValue(nonFilledError)) {
      return;
    }

    const passedSubmission = toValue(passedSubmissionOnce);
    set(passedSubmissionOnce, true);

    if (passedSubmission) {
      set(shouldBlockValidation, false);
    } else if (toValue(value)) {
      set(shouldBlockValidation, false);
    } else {
      set(shouldBlockValidation, true);
    }
  }
});

onMounted(() => {
  updateCurrentLength();
});
</script>

<template>
  <section v-show="isEnabled">
    <div style="position: relative">
      <textarea
        ref="inputRef"
        class="configurator-textarea-input"
        :maxlength="limit"
        :placeholder="placeholder"
        :invalid="shouldBlockValidation"
        v-model="value"
        @update:model-value="
          (val: string) => {
            setValue(val);
            debouncedUpdateCurrentLength();
          }
        "
        @input="debouncedUpdateCurrentLength"
      ></textarea>

      <output :style="{ position: 'absolute', bottom: '1rem', right: '1rem' }"> {{ currentLength }}/{{ limit }} </output>
    </div>

    <Transition name="fade-up">
      <small v-if="shouldBlockValidation" class="v-validation-message">
        {{ nonFilledError }}
      </small>
    </Transition>
  </section>
</template>
